<asax-sky-view-aladin-sky-layers-slider [skyLayers]="skyLayers | async"

                                        [optionsViewStyle]="optionsViewStyle"
                                        [optionsViewPlacement]="optionsViewPlacement"

                                        (outBaseImageForAladin)="onBaseImageForAladin($event)"
                                        (outOverlayImageForAladin)="onOverlayImageForAladin($event)"
                                        (outAlphaForAladin)="onAlphaForAladin($event)"

                                        (outBaseImageForProgress)="baseImageForProgress=$event"
                                        (outOverlayImageForProgress)="overlayImageForProgress=$event"
                                        (outAlphaForProgress)="alphaForProgress=$event"
                                        (outIndexActiveSkyLayer)="indexActiveSky=$event">
  <popContent *ngTemplateOutlet="popoverContent"></popContent>
</asax-sky-view-aladin-sky-layers-slider>

<ng-template #popoverContent>
  <ngb-accordion #accordion="ngbAccordion"
                 (mouseleave)="accordion.collapse('toggle-1')"
                 (mouseenter)="accordion.expand('toggle-1')">
    <ngb-panel id="toggle-1">
      <ng-template ngbPanelHeader let-opened="opened">
        <div class="accordion-button me-3" [class.collapsed]="!opened" *ngIf="!opened">
          <asax-sky-view-aladin-sky-layers-progress [baseImage]="baseImageForProgress"
                                                    [overlayImage]="overlayImageForProgress"
                                                    [alpha]="alphaForProgress">
          </asax-sky-view-aladin-sky-layers-progress>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <asax-sky-view-aladin-sky-layers-options [skyLayers]="skyLayers | async"
                                                 [indexActiveSky]="indexActiveSky"
                                                 (outSkyLayers)="onOutSkyLayers($event)">
        </asax-sky-view-aladin-sky-layers-options>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</ng-template>
